"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.town = exports.postcode = exports.name = exports.line3 = exports.line2 = exports.line1 = exports.country = exports.addressConfig = exports.AddressDefinition = void 0;

var _component = require("../../types/component");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _textfieldConfig = require("../../fields/Textfield/textfieldConfig");

var _config = require("../config");

var _countryList = _interopRequireDefault(require("../../utils/countryList"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _textfieldConfig.TextfieldDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _component.ComponentElementDefinition;
});

var name = {
  autoComplete: 'nope',
  key: 'name',
  label: 'Name',
  maxLength: 250,
  type: 'text',
  ui: {
    classes: 'col span_6_of_12'
  },
  validation: []
};
exports.name = name;
var line1 = {
  autoComplete: 'nope',
  key: 'line1',
  label: 'Address line 1',
  maxLength: 250,
  type: 'text',
  ui: {
    classes: 'col span_6_of_12'
  },
  validation: []
};
exports.line1 = line1;
var line2 = {
  autoComplete: 'nope',
  key: 'line2',
  label: 'Address line 2',
  maxLength: 250,
  type: 'text',
  ui: {
    classes: 'col span_6_of_12'
  },
  validation: []
};
exports.line2 = line2;
var line3 = {
  autoComplete: 'nope',
  key: 'line3',
  label: 'Address line 3',
  maxLength: 250,
  type: 'text',
  ui: {
    classes: 'col span_6_of_12'
  },
  validation: []
};
exports.line3 = line3;
var town = {
  autoComplete: 'nope',
  key: 'town',
  label: 'Town',
  maxLength: 80,
  type: 'text',
  ui: {
    classes: 'col span_6_of_12'
  },
  validation: []
};
exports.town = town;
var postcode = {
  autoComplete: 'nope',
  key: 'postcode',
  label: 'Postcode',
  maxLength: 20,
  type: 'text',
  ui: {
    classes: 'col span_6_of_12'
  },
  validation: []
};
exports.postcode = postcode;
var country = {
  autoComplete: 'nope',
  key: 'country',
  label: 'Country',
  type: 'select',
  items: _countryList["default"],
  ui: {
    classes: 'col span_6_of_12'
  },
  validation: []
};
exports.country = country;
var addressConfig = {
  type: 'address',
  fields: [name, line1, line2, line3, town, postcode, country]
};
exports.addressConfig = addressConfig;

var AddressDefinition = _flowRuntime["default"].type("AddressDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("address")), _flowRuntime["default"].property("options", _flowRuntime["default"].object(_flowRuntime["default"].property("name", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("country", _flowRuntime["default"]["boolean"]()))))));

exports.AddressDefinition = AddressDefinition;